const REQUEST_FORM_URL = 'https://form.jotform.com/232046427365152';

export const useRequestEdit = (): (() => void) => {
    const onRequestEdit = (): void => {
        window.open(REQUEST_FORM_URL, '_blank');
    };

    return onRequestEdit;
};
